// Client-side search over the build-time index (/regions-data/
// search-index.json) — the anonymous twin of the search_all RPC, with
// the same matching semantics: 2-char queries match word starts, 3+
// chars match substrings, both diacritic-folded; results rank exact
// label > prefix > substring, then alphabetically, capped at limit.
// Entries: { kind, id, label, names[], anbaugebiet, bereich, ort,
//            latitude, longitude, notable, vdp_gg_eligible,
//            official_grosses_gewaechs_eligible, description }

export const searchFold = (v) => String(v ?? '')
  .toLowerCase()
  .replace(/ß/g, 'ss')
  .normalize('NFD').replace(/[̀-ͯ]/g, '')
  .trim();

const wordStarts = (name, q) => {
  const folded = searchFold(name);
  if (folded.startsWith(q)) return true;
  return folded.split(/[^a-z0-9]+/).some(tok => tok.startsWith(q));
};

export function searchStaticIndex(entries, query, limit = 30) {
  const q = searchFold(query);
  if (q.length < 2) return [];
  const substr = q.length >= 3;
  const hits = [];
  for (const e of entries) {
    const names = e.names ?? [e.label];
    const matched = substr
      ? names.some(n => searchFold(n).includes(q))
      : names.some(n => wordStarts(n, q));
    if (!matched) continue;
    const label = searchFold(e.label);
    const rank = label === q ? 0 : label.startsWith(q) ? 1 : 2;
    hits.push({ rank, e });
  }
  hits.sort((a, b) => a.rank - b.rank || String(a.e.label).localeCompare(String(b.e.label)));
  return hits.slice(0, limit).map(({ e }) => ({
    kind: e.kind,
    id: e.id,
    label: e.label,
    anbaugebiet: e.anbaugebiet ?? null,
    bereich: e.bereich ?? null,
    ort: e.ort ?? null,
    latitude: e.latitude ?? null,
    longitude: e.longitude ?? null,
    notable: !!e.notable,
    vdp_gg_eligible: !!e.vdp_gg_eligible,
    official_grosses_gewaechs_eligible: !!e.official_grosses_gewaechs_eligible,
    description: e.description ?? null,
  }));
}
